import type { ValuesType } from 'utility-types'

export const SUSTAINABILITY_ATTRIBUTES = [
  'sustainability',
  'sustainabilityCertificates',
  'sustainabilityIcons',
  'sustainabilityMaterials',
]

export const ONE_SIZE_KEY = 'one_size'
